module.exports = __webpack_public_path__ + "img/exp3.822d6699.png";